import _ from "lodash";
import {
    ADD_VALUE_MODEL,
    FETCH_VALUE_MODEL,
    FETCH_VALUE_MODELS,
    FETCH_COST_VALUE_DRIVER,
    ADD_COST_VALUE_DRIVER_LABOR,
    EDIT_COST_VALUE_DRIVER_LABOR,
    DELETE_COST_VALUE_DRIVER_LABOR,
    ADD_COST_VALUE_DRIVER_CS,
    EDIT_COST_VALUE_DRIVER_CS,
    DELETE_COST_VALUE_DRIVER_CS,
    ADD_COST_VALUE_DRIVER_OPERATING,
    EDIT_COST_VALUE_DRIVER_OPERATING,
    DELETE_COST_VALUE_DRIVER_OPERATING,
    ADD_COST_VALUE_DRIVER_RANDD,
    EDIT_COST_VALUE_DRIVER_RANDD,
    DELETE_COST_VALUE_DRIVER_RANDD,
    ADD_COST_VALUE_DRIVER_INVESTMENT,
    EDIT_COST_VALUE_DRIVER_INVESTMENT,
    DELETE_COST_VALUE_DRIVER_INVESTMENT,
    ADD_COST_VALUE_DRIVER_COMPLIANCE,
    EDIT_COST_VALUE_DRIVER_COMPLIANCE,
    DELETE_COST_VALUE_DRIVER_COMPLIANCE,
    ADD_COST_VALUE_DRIVER_INVENTORY,
    EDIT_COST_VALUE_DRIVER_INVENTORY,
    DELETE_COST_VALUE_DRIVER_INVENTORY,
    ADD_COST_VALUE_DRIVER_FACILITY,
    EDIT_COST_VALUE_DRIVER_FACILITY,
    DELETE_COST_VALUE_DRIVER_FACILITY,
    ADD_COST_VALUE_DRIVER_EQUIPMENT,
    EDIT_COST_VALUE_DRIVER_EQUIPMENT,
    DELETE_COST_VALUE_DRIVER_EQUIPMENT,
    EDIT_COST_VALUE_DRIVER_UPGRADE,
    DELETE_COST_VALUE_DRIVER_UPGRADE,
    ADD_COST_VALUE_DRIVER_UPGRADE,
    ADD_REVENUE_VALUE_DRIVER_TTM,
    EDIT_REVENUE_VALUE_DRIVER_TTM,
    DELETE_REVENUE_VALUE_DRIVER_TTM,
    ADD_REVENUE_VALUE_DRIVER_SALES,
    EDIT_REVENUE_VALUE_DRIVER_SALES,
    DELETE_REVENUE_VALUE_DRIVER_SALES,
    ADD_REVENUE_VALUE_DRIVER_MARKETING,
    EDIT_REVENUE_VALUE_DRIVER_MARKETING,
    DELETE_REVENUE_VALUE_DRIVER_MARKETING,
    ADD_REVENUE_VALUE_DRIVER_CLV,
    EDIT_REVENUE_VALUE_DRIVER_CLV,
    DELETE_REVENUE_VALUE_DRIVER_CLV,
    EDIT_VARIABLE_VALUES,
    VIEW_VALUE_MODEL,
    ADD_REVENUE_VALUE_DRIVER_IR,
    EDIT_REVENUE_VALUE_DRIVER_IR,
    DELETE_REVENUE_VALUE_DRIVER_IR,
    CLEAR_COST_VALUE_DRIVER,
    ADD_RISK_VALUE_DRIVER_REGULATORY,
    EDIT_RISK_VALUE_DRIVER_REGULATORY,
    DELETE_RISK_VALUE_DRIVER_REGULATORY,
    ADD_RISK_VALUE_DRIVER_LITIGATION,
    EDIT_RISK_VALUE_DRIVER_LITIGATION,
    DELETE_RISK_VALUE_DRIVER_LITIGATION,
    ADD_RISK_VALUE_DRIVER_REVENUE,
    EDIT_RISK_VALUE_DRIVER_REVENUE,
    DELETE_RISK_VALUE_DRIVER_REVENUE,
    ADD_COST_VALUE_DRIVER_ACCOUNTING,
    ADD_COST_VALUE_DRIVER_HR,
    ADD_COST_VALUE_DRIVER_BD,
    ADD_COST_VALUE_DRIVER_MARCOM,
    ADD_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
    ADD_COST_VALUE_DRIVER_IT,
    ADD_COST_VALUE_DRIVER_LEGAL,
    ADD_COST_VALUE_DRIVER_PROCUREMENT,
    EDIT_COST_VALUE_DRIVER_ACCOUNTING,
    EDIT_COST_VALUE_DRIVER_HR,
    EDIT_COST_VALUE_DRIVER_BD,
    EDIT_COST_VALUE_DRIVER_MARCOM,
    EDIT_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
    EDIT_COST_VALUE_DRIVER_IT,
    EDIT_COST_VALUE_DRIVER_LEGAL,
    EDIT_COST_VALUE_DRIVER_PROCUREMENT,
    DELETE_COST_VALUE_DRIVER_ACCOUNTING,
    DELETE_COST_VALUE_DRIVER_HR,
    DELETE_COST_VALUE_DRIVER_BD,
    DELETE_COST_VALUE_DRIVER_MARCOM,
    DELETE_COST_VALUE_DRIVER_CUSTOMER_SUCCESS,
    DELETE_COST_VALUE_DRIVER_IT,
    DELETE_COST_VALUE_DRIVER_LEGAL,
    DELETE_COST_VALUE_DRIVER_PROCUREMENT,
    ADD_COST_VALUE_DRIVER_PAYMENT,
    EDIT_COST_VALUE_DRIVER_PAYMENT,
    DELETE_COST_VALUE_DRIVER_PAYMENT,
    QUERY_COST_ITEM,
    CLEAR_QUERY_RESULT,
    QUERY_COST_TYPE,
    QUERY_EMPLOYEE_TYPE,
    QUERY_EMPLOYEE_CATEGORY,
    QUERY_INVESTMENT_PROJECT,
    QUERY_INVESTMENT_ASSET,
    QUERY_PRODUCT_TYPE,
    QUERY_REVENUE_TYPE,
    FETCH_IMPACT_ANALYSIS,
    ADD_IMPACT_AREA,
    EDIT_IMPACT_ANALYSIS,
    FETCH_DRIVER_ANALYSIS,
    EDIT_REVENUE_MODEL,
} from '../actions/types'

const INITIAL_STATE = {
    valueModel: {},
    valueModels: [],
    viewValueModel: {},
    costStructure: {},
    queryResult: {},
}

const valueReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case ADD_VALUE_MODEL:
            return { ...state, valueModel: { ...state.valueModel, [action.payload.value_models.id]: action.payload.value_models } }
        case FETCH_VALUE_MODEL:
            return { ...state, valueModel: { ...state.valueModel, [action.payload.value_models.id]: action.payload.value_models } }
        case FETCH_VALUE_MODELS:
            return { ...state, valueModels: action.payload.value_models }
        case FETCH_COST_VALUE_DRIVER:
            return { ...state, costStructure: action.payload.cost_structure };
        case CLEAR_COST_VALUE_DRIVER:
            return { ...state, costStructure: {} };

        case FETCH_IMPACT_ANALYSIS:
            const impactAnalysis = action.payload;

            const updatedImpactValueModel = {
                ...state.valueModel[impactAnalysis.id],
                step: impactAnalysis.step,
                impact_analysis: impactAnalysis.impact_analysis
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [impactAnalysis.id]: updatedImpactValueModel
                }
            };

        case ADD_IMPACT_AREA:
            const impactArea = action.payload;

            // Update only the array corresponding to the given area within the impact_analysis object
            const updatedAreaArray = [
                ...state.valueModel[impactArea.id].impact_analysis[impactArea.area],
                impactArea.impact_area
            ];

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [impactArea.id]: {
                        ...state.valueModel[impactArea.id],
                        impact_analysis: {
                            ...state.valueModel[impactArea.id].impact_analysis,
                            [impactArea.area]: updatedAreaArray
                        }
                    }
                }
            };

        case EDIT_IMPACT_ANALYSIS: {
            const updateImpactAnalysis = action.payload;

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [updateImpactAnalysis.id]: {
                        ...state.valueModel[updateImpactAnalysis.id],
                        step: updateImpactAnalysis.step,
                        impact_analysis: updateImpactAnalysis.impact_analysis
                    }
                }
            };
        }

        case FETCH_DRIVER_ANALYSIS:
            const driverAnalysis = action.payload;

            const updatedDriverValueModel = {
                ...state.valueModel[driverAnalysis.id],
                step: driverAnalysis.step,
                driver_analysis: driverAnalysis.driver_analysis
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [driverAnalysis.id]: updatedDriverValueModel
                }
            };

        case VIEW_VALUE_MODEL:
            return { ...state, viewValueModel: { ...state.viewValueModel, [action.payload.id]: action.payload.value } }

        case ADD_COST_VALUE_DRIVER_LABOR: {
            const { id, labor_savings, variables } = action.payload;
            const updatedLaborSavings = [
                ...state.valueModel[id].cost_value_driver.labor_savings,
                labor_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                labor_savings: updatedLaborSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_LABOR:
            // Create a deep copy of the state
            const newStateLabor = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectLabor = newStateLabor.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectLabor) {
                // Update variables
                valueModelObjectLabor.variables = action.payload.variables

                const laborValueDriverObject = valueModelObjectLabor.cost_value_driver.labor_savings.find(labor_driver => labor_driver.id === action.payload.labor_savings.id);

                // If the attribute object is found, update its properties
                if (laborValueDriverObject) {
                    Object.assign(laborValueDriverObject, action.payload.labor_savings);
                }
            }

            // Return the modified state
            return newStateLabor;

        case DELETE_COST_VALUE_DRIVER_LABOR:
            const { id, driver_id, variables } = action.payload;
            const deletedLaborSavings = _.filter(state.valueModel[id].cost_value_driver.labor_savings, labor_driver => labor_driver.id !== driver_id);

            const deletedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                labor_savings: deletedLaborSavings
            };

            const deletedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: deletedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: deletedValueModel
                }
            };

        case ADD_COST_VALUE_DRIVER_CS: {
            const { id, cs_savings, variables } = action.payload;
            const updatedCSSavings = [
                ...state.valueModel[id].cost_value_driver.cs_savings,
                cs_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                cs_savings: updatedCSSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_CS:
            // Create a deep copy of the state
            const newStateCS = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectCS = newStateCS.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectCS) {
                // Update variables
                valueModelObjectCS.variables = action.payload.variables

                const csValueDriverObject = valueModelObjectCS.cost_value_driver.cs_savings.find(cs_driver => cs_driver.id === action.payload.cs_savings.id);

                // If the attribute object is found, update its properties
                if (csValueDriverObject) {
                    Object.assign(csValueDriverObject, action.payload.cs_savings);
                }
            }

            // Return the modified state
            return newStateCS;

        case DELETE_COST_VALUE_DRIVER_CS:
            const csDriver = action.payload;
            const deletedCSSavings = _.filter(state.valueModel[csDriver.id].cost_value_driver.cs_savings, cs_driver => cs_driver.id !== csDriver.driver_id);

            const deletedCostValueDriverCS = {
                ...state.valueModel[csDriver.id].cost_value_driver,
                cs_savings: deletedCSSavings
            };

            const deletedValueModelCS = {
                ...state.valueModel[csDriver.id],
                cost_value_driver: deletedCostValueDriverCS,
                variables: csDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [csDriver.id]: deletedValueModelCS
                }
            };

        case ADD_COST_VALUE_DRIVER_OPERATING: {
            const { id, operating_savings, variables } = action.payload;
            const updatedOperatingSavings = [
                ...state.valueModel[id].cost_value_driver.operating_savings,
                operating_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                operating_savings: updatedOperatingSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_OPERATING:
            // Create a deep copy of the state
            const newStateOperating = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectOperating = newStateOperating.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectOperating) {
                // Update variables
                valueModelObjectOperating.variables = action.payload.variables

                const operatingValueDriverObject = valueModelObjectOperating.cost_value_driver.operating_savings.find(operating_driver => operating_driver.id === action.payload.operating_savings.id);

                // If the attribute object is found, update its properties
                if (operatingValueDriverObject) {
                    Object.assign(operatingValueDriverObject, action.payload.operating_savings);
                }
            }

            // Return the modified state
            return newStateOperating;

        case DELETE_COST_VALUE_DRIVER_OPERATING:
            const operatingDriver = action.payload;
            const deletedOperatingSavings = _.filter(state.valueModel[operatingDriver.id].cost_value_driver.operating_savings, operating_driver => operating_driver.id !== operatingDriver.driver_id);

            const deletedCostValueDriverOperating = {
                ...state.valueModel[operatingDriver.id].cost_value_driver,
                operating_savings: deletedOperatingSavings
            };

            const deletedValueModelOperating = {
                ...state.valueModel[operatingDriver.id],
                cost_value_driver: deletedCostValueDriverOperating,
                variables: operatingDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [operatingDriver.id]: deletedValueModelOperating
                }
            };

        // Finance & Accounting
        case ADD_COST_VALUE_DRIVER_ACCOUNTING: {
            const { id, accounting_savings, variables } = action.payload;
            const updatedAccounting = [
                ...state.valueModel[id].cost_value_driver.accounting_savings,
                accounting_savings
            ];
            const updatedCostValueDriver1 = {
                ...state.valueModel[id].cost_value_driver,
                accounting_savings: updatedAccounting
            };
            const updatedValueModel1 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver1,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel1
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_ACCOUNTING: {
            const newState1 = _.cloneDeep(state);
            const vm1 = newState1.valueModel[action.payload.id];
            if (vm1) {
                vm1.variables = action.payload.variables;
                const obj = vm1.cost_value_driver.accounting_savings
                    .find(e => e.id === action.payload.accounting_savings.id);
                if (obj) Object.assign(obj, action.payload.accounting_savings);
            }
            return newState1;
        }

        case DELETE_COST_VALUE_DRIVER_ACCOUNTING: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.accounting_savings,
                e => e.id !== driver_id
            );
            const cvd1 = {
                ...state.valueModel[id].cost_value_driver,
                accounting_savings: kept
            };
            const vmDel1 = {
                ...state.valueModel[id],
                cost_value_driver: cvd1,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel1
                }
            };
        }


        // HR & People
        case ADD_COST_VALUE_DRIVER_HR: {
            const { id, hr_savings, variables } = action.payload;
            const updatedHR = [
                ...state.valueModel[id].cost_value_driver.hr_savings,
                hr_savings
            ];
            const updatedCostValueDriver2 = {
                ...state.valueModel[id].cost_value_driver,
                hr_savings: updatedHR
            };
            const updatedValueModel2 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver2,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel2
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_HR: {
            const newState2 = _.cloneDeep(state);
            const vm2 = newState2.valueModel[action.payload.id];
            if (vm2) {
                vm2.variables = action.payload.variables;
                const obj = vm2.cost_value_driver.hr_savings
                    .find(e => e.id === action.payload.hr_savings.id);
                if (obj) Object.assign(obj, action.payload.hr_savings);
            }
            return newState2;
        }

        case DELETE_COST_VALUE_DRIVER_HR: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.hr_savings,
                e => e.id !== driver_id
            );
            const cvd2 = {
                ...state.valueModel[id].cost_value_driver,
                hr_savings: kept
            };
            const vmDel2 = {
                ...state.valueModel[id],
                cost_value_driver: cvd2,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel2
                }
            };
        }


        // Sales & Business Development
        case ADD_COST_VALUE_DRIVER_BD: {
            const { id, sales_savings, variables } = action.payload;
            const updatedSales = [
                ...state.valueModel[id].cost_value_driver.sales_savings,
                sales_savings
            ];
            const updatedCostValueDriver3 = {
                ...state.valueModel[id].cost_value_driver,
                sales_savings: updatedSales
            };
            const updatedValueModel3 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver3,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel3
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_BD: {
            const newState3 = _.cloneDeep(state);
            const vm3 = newState3.valueModel[action.payload.id];
            if (vm3) {
                vm3.variables = action.payload.variables;
                const obj = vm3.cost_value_driver.sales_savings
                    .find(e => e.id === action.payload.sales_savings.id);
                if (obj) Object.assign(obj, action.payload.sales_savings);
            }
            return newState3;
        }

        case DELETE_COST_VALUE_DRIVER_BD: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.sales_savings,
                e => e.id !== driver_id
            );
            const cvd3 = {
                ...state.valueModel[id].cost_value_driver,
                sales_savings: kept
            };
            const vmDel3 = {
                ...state.valueModel[id],
                cost_value_driver: cvd3,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel3
                }
            };
        }


        // Marketing & Communications
        case ADD_COST_VALUE_DRIVER_MARCOM: {
            const { id, marketing_savings, variables } = action.payload;
            const updatedMarketing = [
                ...state.valueModel[id].cost_value_driver.marketing_savings,
                marketing_savings
            ];
            const updatedCostValueDriver4 = {
                ...state.valueModel[id].cost_value_driver,
                marketing_savings: updatedMarketing
            };
            const updatedValueModel4 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver4,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel4
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_MARCOM: {
            const newState4 = _.cloneDeep(state);
            const vm4 = newState4.valueModel[action.payload.id];
            if (vm4) {
                vm4.variables = action.payload.variables;
                const obj = vm4.cost_value_driver.marketing_savings
                    .find(e => e.id === action.payload.marketing_savings.id);
                if (obj) Object.assign(obj, action.payload.marketing_savings);
            }
            return newState4;
        }

        case DELETE_COST_VALUE_DRIVER_MARCOM: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.marketing_savings,
                e => e.id !== driver_id
            );
            const cvd4 = {
                ...state.valueModel[id].cost_value_driver,
                marketing_savings: kept
            };
            const vmDel4 = {
                ...state.valueModel[id],
                cost_value_driver: cvd4,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel4
                }
            };
        }


        // Customer Success
        case ADD_COST_VALUE_DRIVER_CUSTOMER_SUCCESS: {
            const { id, customer_success_savings, variables } = action.payload;
            const updatedCS = [
                ...state.valueModel[id].cost_value_driver.customer_success_savings,
                customer_success_savings
            ];
            const updatedCostValueDriver5 = {
                ...state.valueModel[id].cost_value_driver,
                customer_success_savings: updatedCS
            };
            const updatedValueModel5 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver5,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel5
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_CUSTOMER_SUCCESS: {
            const newState5 = _.cloneDeep(state);
            const vm5 = newState5.valueModel[action.payload.id];
            if (vm5) {
                vm5.variables = action.payload.variables;
                const obj = vm5.cost_value_driver.customer_success_savings
                    .find(e => e.id === action.payload.customer_success_savings.id);
                if (obj) Object.assign(obj, action.payload.customer_success_savings);
            }
            return newState5;
        }

        case DELETE_COST_VALUE_DRIVER_CUSTOMER_SUCCESS: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.customer_success_savings,
                e => e.id !== driver_id
            );
            const cvd5 = {
                ...state.valueModel[id].cost_value_driver,
                customer_success_savings: kept
            };
            const vmDel5 = {
                ...state.valueModel[id],
                cost_value_driver: cvd5,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel5
                }
            };
        }


        // IT & Infrastructure
        case ADD_COST_VALUE_DRIVER_IT: {
            const { id, it_savings, variables } = action.payload;
            const updatedIT = [
                ...state.valueModel[id].cost_value_driver.it_savings,
                it_savings
            ];
            const updatedCostValueDriver6 = {
                ...state.valueModel[id].cost_value_driver,
                it_savings: updatedIT
            };
            const updatedValueModel6 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver6,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel6
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_IT: {
            const newState6 = _.cloneDeep(state);
            const vm6 = newState6.valueModel[action.payload.id];
            if (vm6) {
                vm6.variables = action.payload.variables;
                const obj = vm6.cost_value_driver.it_savings
                    .find(e => e.id === action.payload.it_savings.id);
                if (obj) Object.assign(obj, action.payload.it_savings);
            }
            return newState6;
        }

        case DELETE_COST_VALUE_DRIVER_IT: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.it_savings,
                e => e.id !== driver_id
            );
            const cvd6 = {
                ...state.valueModel[id].cost_value_driver,
                it_savings: kept
            };
            const vmDel6 = {
                ...state.valueModel[id],
                cost_value_driver: cvd6,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel6
                }
            };
        }


        // Legal & Compliance
        case ADD_COST_VALUE_DRIVER_LEGAL: {
            const { id, legal_savings, variables } = action.payload;
            const updatedLegal = [
                ...state.valueModel[id].cost_value_driver.legal_savings,
                legal_savings
            ];
            const updatedCostValueDriver7 = {
                ...state.valueModel[id].cost_value_driver,
                legal_savings: updatedLegal
            };
            const updatedValueModel7 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver7,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel7
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_LEGAL: {
            const newState7 = _.cloneDeep(state);
            const vm7 = newState7.valueModel[action.payload.id];
            if (vm7) {
                vm7.variables = action.payload.variables;
                const obj = vm7.cost_value_driver.legal_savings
                    .find(e => e.id === action.payload.legal_savings.id);
                if (obj) Object.assign(obj, action.payload.legal_savings);
            }
            return newState7;
        }

        case DELETE_COST_VALUE_DRIVER_LEGAL: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.legal_savings,
                e => e.id !== driver_id
            );
            const cvd7 = {
                ...state.valueModel[id].cost_value_driver,
                legal_savings: kept
            };
            const vmDel7 = {
                ...state.valueModel[id],
                cost_value_driver: cvd7,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel7
                }
            };
        }


        // Procurement & Purchasing
        case ADD_COST_VALUE_DRIVER_PROCUREMENT: {
            const { id, procurement_savings, variables } = action.payload;
            const updatedProc = [
                ...state.valueModel[id].cost_value_driver.procurement_savings,
                procurement_savings
            ];
            const updatedCostValueDriver8 = {
                ...state.valueModel[id].cost_value_driver,
                procurement_savings: updatedProc
            };
            const updatedValueModel8 = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver8,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel8
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_PROCUREMENT: {
            const newState8 = _.cloneDeep(state);
            const vm8 = newState8.valueModel[action.payload.id];
            if (vm8) {
                vm8.variables = action.payload.variables;
                const obj = vm8.cost_value_driver.procurement_savings
                    .find(e => e.id === action.payload.procurement_savings.id);
                if (obj) Object.assign(obj, action.payload.procurement_savings);
            }
            return newState8;
        }

        case DELETE_COST_VALUE_DRIVER_PROCUREMENT: {
            const { id, driver_id, variables } = action.payload;
            const kept = _.filter(
                state.valueModel[id].cost_value_driver.procurement_savings,
                e => e.id !== driver_id
            );
            const cvd8 = {
                ...state.valueModel[id].cost_value_driver,
                procurement_savings: kept
            };
            const vmDel8 = {
                ...state.valueModel[id],
                cost_value_driver: cvd8,
                variables
            };
            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: vmDel8
                }
            };
        }

        case ADD_COST_VALUE_DRIVER_RANDD: {
            const { id, randd_savings, variables } = action.payload;
            const updatedRandDSavings = [
                ...state.valueModel[id].cost_value_driver.randd_savings,
                randd_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                randd_savings: updatedRandDSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_RANDD:
            // Create a deep copy of the state
            const newStateRandD = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectRandD = newStateRandD.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectRandD) {
                // Update variables
                valueModelObjectRandD.variables = action.payload.variables

                const randDValueDriverObject = valueModelObjectRandD.cost_value_driver.randd_savings.find(randd_driver => randd_driver.id === action.payload.randd_savings.id);

                // If the attribute object is found, update its properties
                if (randDValueDriverObject) {
                    Object.assign(randDValueDriverObject, action.payload.randd_savings);
                }
            }

            // Return the modified state
            return newStateRandD;

        case DELETE_COST_VALUE_DRIVER_RANDD:
            const randDDriver = action.payload;
            const deletedRandDSavings = _.filter(state.valueModel[randDDriver.id].cost_value_driver.randd_savings, randd_driver => randd_driver.id !== randDDriver.driver_id);

            const deletedCostValueDriverRandD = {
                ...state.valueModel[randDDriver.id].cost_value_driver,
                randd_savings: deletedRandDSavings
            };

            const deletedValueModelRandD = {
                ...state.valueModel[randDDriver.id],
                cost_value_driver: deletedCostValueDriverRandD,
                variables: randDDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [randDDriver.id]: deletedValueModelRandD
                }
            };

        case ADD_COST_VALUE_DRIVER_INVESTMENT: {
            const { id, investment_savings, variables } = action.payload;
            const updatedInvestmentSavings = [
                ...state.valueModel[id].cost_value_driver.investment_savings,
                investment_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                investment_savings: updatedInvestmentSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_INVESTMENT:
            // Create a deep copy of the state
            const newStateInvestment = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectInvestment = newStateInvestment.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectInvestment) {
                // Update variables
                valueModelObjectInvestment.variables = action.payload.variables

                const investmentValueDriverObject = valueModelObjectInvestment.cost_value_driver.investment_savings.find(investment_driver => investment_driver.id === action.payload.investment_savings.id);

                // If the attribute object is found, update its properties
                if (investmentValueDriverObject) {
                    Object.assign(investmentValueDriverObject, action.payload.investment_savings);
                }
            }

            // Return the modified state
            return newStateInvestment;

        case DELETE_COST_VALUE_DRIVER_INVESTMENT:
            const investmentDriver = action.payload;
            const deletedInvestmentSavings = _.filter(state.valueModel[investmentDriver.id].cost_value_driver.investment_savings, investment_driver => investment_driver.id !== investmentDriver.driver_id);

            const deletedCostValueDriverInvestment = {
                ...state.valueModel[investmentDriver.id].cost_value_driver,
                investment_savings: deletedInvestmentSavings
            };

            const deletedValueModelInvestment = {
                ...state.valueModel[investmentDriver.id],
                cost_value_driver: deletedCostValueDriverInvestment,
                variables: investmentDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [investmentDriver.id]: deletedValueModelInvestment
                }
            };

        case ADD_COST_VALUE_DRIVER_COMPLIANCE: {
            const { id, compliance_savings, variables } = action.payload;
            const updatedComplianceSavings = [
                ...state.valueModel[id].cost_value_driver.compliance_savings,
                compliance_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                compliance_savings: updatedComplianceSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_COMPLIANCE:
            // Create a deep copy of the state
            const newStateCompliance = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectCompliance = newStateCompliance.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectCompliance) {
                // Update variables
                valueModelObjectCompliance.variables = action.payload.variables

                const complianceValueDriverObject = valueModelObjectCompliance.cost_value_driver.compliance_savings.find(compliance_driver => compliance_driver.id === action.payload.compliance_savings.id);

                // If the attribute object is found, update its properties
                if (complianceValueDriverObject) {
                    Object.assign(complianceValueDriverObject, action.payload.compliance_savings);
                }
            }

            // Return the modified state
            return newStateCompliance;

        case DELETE_COST_VALUE_DRIVER_COMPLIANCE:
            const complianceDriver = action.payload;
            const deletedComplianceSavings = _.filter(state.valueModel[complianceDriver.id].cost_value_driver.compliance_savings, compliance_driver => compliance_driver.id !== complianceDriver.driver_id);

            const deletedCostValueDriverCompliance = {
                ...state.valueModel[complianceDriver.id].cost_value_driver,
                compliance_savings: deletedComplianceSavings
            };

            const deletedValueModelCompliance = {
                ...state.valueModel[complianceDriver.id],
                cost_value_driver: deletedCostValueDriverCompliance,
                variables: complianceDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [complianceDriver.id]: deletedValueModelCompliance
                }
            };

        case ADD_COST_VALUE_DRIVER_PAYMENT: {
            const { id, payment_savings, variables } = action.payload;
            const updatedPaymentSavings = [
                ...state.valueModel[id].cost_value_driver.payment_savings,
                payment_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                payment_savings: updatedPaymentSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_PAYMENT:
            // Create a deep copy of the state
            const newStatePayment = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectPayment = newStatePayment.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectPayment) {
                // Update variables
                valueModelObjectPayment.variables = action.payload.variables

                const paymentValueDriverObject = valueModelObjectPayment.cost_value_driver.payment_savings.find(payment_driver => payment_driver.id === action.payload.payment_savings.id);

                // If the attribute object is found, update its properties
                if (paymentValueDriverObject) {
                    Object.assign(paymentValueDriverObject, action.payload.payment_savings);
                }
            }

            // Return the modified state
            return newStatePayment;

        case DELETE_COST_VALUE_DRIVER_PAYMENT:
            const paymentDriver = action.payload;
            const deletedPaymentSavings = _.filter(state.valueModel[paymentDriver.id].cost_value_driver.payment_savings, payment_driver => payment_driver.id !== paymentDriver.driver_id);

            const deletedCostValueDriverPayment = {
                ...state.valueModel[paymentDriver.id].cost_value_driver,
                payment_savings: deletedPaymentSavings
            };

            const deletedValueModelPayment = {
                ...state.valueModel[paymentDriver.id],
                cost_value_driver: deletedCostValueDriverPayment,
                variables: paymentDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [paymentDriver.id]: deletedValueModelPayment
                }
            };

        case ADD_COST_VALUE_DRIVER_INVENTORY: {
            const { id, inventory_savings, variables } = action.payload;
            const updatedInventorySavings = [
                ...state.valueModel[id].cost_value_driver.inventory_savings,
                inventory_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                inventory_savings: updatedInventorySavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_INVENTORY:
            // Create a deep copy of the state
            const newStateInventory = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectInventory = newStateInventory.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectInventory) {
                // Update variables
                valueModelObjectInventory.variables = action.payload.variables

                const inventoryValueDriverObject = valueModelObjectInventory.cost_value_driver.inventory_savings.find(inventory_driver => inventory_driver.id === action.payload.inventory_savings.id);

                // If the attribute object is found, update its properties
                if (inventoryValueDriverObject) {
                    Object.assign(inventoryValueDriverObject, action.payload.inventory_savings);
                }
            }

            // Return the modified state
            return newStateInventory;

        case DELETE_COST_VALUE_DRIVER_INVENTORY:
            const inventoryDriver = action.payload;
            const deletedInventorySavings = _.filter(state.valueModel[inventoryDriver.id].cost_value_driver.inventory_savings, inventory_driver => inventory_driver.id !== inventoryDriver.driver_id);

            const deletedCostValueDriverInventory = {
                ...state.valueModel[inventoryDriver.id].cost_value_driver,
                inventory_savings: deletedInventorySavings
            };

            const deletedValueModelInventory = {
                ...state.valueModel[inventoryDriver.id],
                cost_value_driver: deletedCostValueDriverInventory,
                variables: inventoryDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [inventoryDriver.id]: deletedValueModelInventory
                }
            };

        case ADD_COST_VALUE_DRIVER_FACILITY: {
            const { id, facility_savings, variables } = action.payload;
            const updatedFacilitySavings = [
                ...state.valueModel[id].cost_value_driver.facility_savings,
                facility_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                facility_savings: updatedFacilitySavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_FACILITY:
            // Create a deep copy of the state
            const newStateFacility = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectFacility = newStateFacility.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectFacility) {
                // Update variables
                valueModelObjectFacility.variables = action.payload.variables

                const facilityValueDriverObject = valueModelObjectFacility.cost_value_driver.facility_savings.find(facility_driver => facility_driver.id === action.payload.facility_savings.id);

                // If the attribute object is found, update its properties
                if (facilityValueDriverObject) {
                    Object.assign(facilityValueDriverObject, action.payload.facility_savings);
                }
            }

            // Return the modified state
            return newStateFacility;

        case DELETE_COST_VALUE_DRIVER_FACILITY:
            const facilityDriver = action.payload;
            const deletedFacilitySavings = _.filter(state.valueModel[facilityDriver.id].cost_value_driver.facility_savings, facility_driver => facility_driver.id !== facilityDriver.driver_id);

            const deletedCostValueDriverFacility = {
                ...state.valueModel[facilityDriver.id].cost_value_driver,
                facility_savings: deletedFacilitySavings
            };

            const deletedValueModelFacility = {
                ...state.valueModel[facilityDriver.id],
                cost_value_driver: deletedCostValueDriverFacility,
                variables: facilityDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [facilityDriver.id]: deletedValueModelFacility
                }
            };

        case ADD_COST_VALUE_DRIVER_EQUIPMENT: {
            const { id, equipment_savings, variables } = action.payload;
            const updatedEquipmentSavings = [
                ...state.valueModel[id].cost_value_driver.equipment_savings,
                equipment_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                equipment_savings: updatedEquipmentSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_EQUIPMENT:
            // Create a deep copy of the state
            const newStateEquipment = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectEquipment = newStateEquipment.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectEquipment) {
                // Update variables
                valueModelObjectEquipment.variables = action.payload.variables

                const equipmentValueDriverObject = valueModelObjectEquipment.cost_value_driver.equipment_savings.find(equipment_driver => equipment_driver.id === action.payload.equipment_savings.id);

                // If the attribute object is found, update its properties
                if (equipmentValueDriverObject) {
                    Object.assign(equipmentValueDriverObject, action.payload.equipment_savings);
                }
            }

            // Return the modified state
            return newStateEquipment;

        case DELETE_COST_VALUE_DRIVER_EQUIPMENT:
            const equipmentDriver = action.payload;
            const deletedEquipmentSavings = _.filter(state.valueModel[equipmentDriver.id].cost_value_driver.equipment_savings, equipment_driver => equipment_driver.id !== equipmentDriver.driver_id);

            const deletedCostValueDriverEquipment = {
                ...state.valueModel[equipmentDriver.id].cost_value_driver,
                equipment_savings: deletedEquipmentSavings
            };

            const deletedValueModelEquipment = {
                ...state.valueModel[equipmentDriver.id],
                cost_value_driver: deletedCostValueDriverEquipment,
                variables: equipmentDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [equipmentDriver.id]: deletedValueModelEquipment
                }
            };

        case ADD_COST_VALUE_DRIVER_UPGRADE: {
            const { id, upgrade_savings, variables } = action.payload;
            const updatedUpgradeSavings = [
                ...state.valueModel[id].cost_value_driver.upgrade_savings,
                upgrade_savings
            ];

            const updatedCostValueDriver = {
                ...state.valueModel[id].cost_value_driver,
                upgrade_savings: updatedUpgradeSavings
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                cost_value_driver: updatedCostValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_COST_VALUE_DRIVER_UPGRADE:
            // Create a deep copy of the state
            const newStateUpgrade = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectUpgrade = newStateUpgrade.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectUpgrade) {
                // Update variables
                valueModelObjectUpgrade.variables = action.payload.variables

                const upgradeValueDriverObject = valueModelObjectUpgrade.cost_value_driver.upgrade_savings.find(upgrade_driver => upgrade_driver.id === action.payload.upgrade_savings.id);

                // If the attribute object is found, update its properties
                if (upgradeValueDriverObject) {
                    Object.assign(upgradeValueDriverObject, action.payload.upgrade_savings);
                }
            }

            // Return the modified state
            return newStateUpgrade;

        case DELETE_COST_VALUE_DRIVER_UPGRADE:
            const upgradeDriver = action.payload;
            const deletedUpgradeSavings = _.filter(state.valueModel[upgradeDriver.id].cost_value_driver.upgrade_savings, upgrade_driver => upgrade_driver.id !== upgradeDriver.driver_id);

            const deletedCostValueDriverUpgrade = {
                ...state.valueModel[upgradeDriver.id].cost_value_driver,
                upgrade_savings: deletedUpgradeSavings
            };

            const deletedValueModelUpgrade = {
                ...state.valueModel[upgradeDriver.id],
                cost_value_driver: deletedCostValueDriverUpgrade,
                variables: upgradeDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [upgradeDriver.id]: deletedValueModelUpgrade
                }
            };

        case ADD_REVENUE_VALUE_DRIVER_TTM: {
            const { id, time_to_market, variables } = action.payload;
            const updatedTTM = [
                ...state.valueModel[id].revenue_value_driver.time_to_market,
                time_to_market
            ];

            const updatedRevenueValueDriver = {
                ...state.valueModel[id].revenue_value_driver,
                time_to_market: updatedTTM
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                revenue_value_driver: updatedRevenueValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_REVENUE_VALUE_DRIVER_TTM:
            // Create a deep copy of the state
            const newStateTTM = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectTTM = newStateTTM.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectTTM) {
                // Update variables
                valueModelObjectTTM.variables = action.payload.variables

                const ttmValueDriverObject = valueModelObjectTTM.revenue_value_driver.time_to_market.find(ttm_driver => ttm_driver.id === action.payload.time_to_market.id);

                // If the attribute object is found, update its properties
                if (ttmValueDriverObject) {
                    Object.assign(ttmValueDriverObject, action.payload.time_to_market);
                }
            }

            // Return the modified state
            return newStateTTM;

        case DELETE_REVENUE_VALUE_DRIVER_TTM:
            const ttmDriver = action.payload;
            const deletedTTM = _.filter(state.valueModel[ttmDriver.id].revenue_value_driver.time_to_market, ttm_driver => ttm_driver.id !== ttmDriver.driver_id);

            const deletedCostValueDriverTTM = {
                ...state.valueModel[ttmDriver.id].revenue_value_driver,
                time_to_market: deletedTTM
            };

            const deletedValueModelTTM = {
                ...state.valueModel[ttmDriver.id],
                revenue_value_driver: deletedCostValueDriverTTM,
                variables: ttmDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [ttmDriver.id]: deletedValueModelTTM
                }
            };

        case ADD_REVENUE_VALUE_DRIVER_SALES: {
            const { id, sales_driven, variables } = action.payload;
            const updatedSales = [
                ...state.valueModel[id].revenue_value_driver.sales_driven,
                sales_driven
            ];

            const updatedRevenueValueDriver = {
                ...state.valueModel[id].revenue_value_driver,
                sales_driven: updatedSales
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                revenue_value_driver: updatedRevenueValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_REVENUE_VALUE_DRIVER_SALES:
            // Create a deep copy of the state
            const newStateSales = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectSales = newStateSales.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectSales) {
                // Update variables
                valueModelObjectSales.variables = action.payload.variables

                const salesValueDriverObject = valueModelObjectSales.revenue_value_driver.sales_driven.find(sales_driver => sales_driver.id === action.payload.sales_driven.id);

                // If the attribute object is found, update its properties
                if (salesValueDriverObject) {
                    Object.assign(salesValueDriverObject, action.payload.sales_driven);
                }
            }

            // Return the modified state
            return newStateSales;

        case DELETE_REVENUE_VALUE_DRIVER_SALES:
            const salesDriver = action.payload;
            const deletedSales = _.filter(state.valueModel[salesDriver.id].revenue_value_driver.sales_driven, sales_driver => sales_driver.id !== salesDriver.driver_id);

            const deletedCostValueDriverSales = {
                ...state.valueModel[salesDriver.id].revenue_value_driver,
                sales_driven: deletedSales
            };

            const deletedValueModelSales = {
                ...state.valueModel[salesDriver.id],
                revenue_value_driver: deletedCostValueDriverSales,
                variables: salesDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [salesDriver.id]: deletedValueModelSales
                }
            };

        case ADD_REVENUE_VALUE_DRIVER_MARKETING: {
            const { id, marketing_driven, variables } = action.payload;
            const updatedMarketing = [
                ...state.valueModel[id].revenue_value_driver.marketing_driven,
                marketing_driven
            ];

            const updatedRevenueValueDriver = {
                ...state.valueModel[id].revenue_value_driver,
                marketing_driven: updatedMarketing
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                revenue_value_driver: updatedRevenueValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_REVENUE_VALUE_DRIVER_MARKETING:
            // Create a deep copy of the state
            const newStateMarketing = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectMarketing = newStateMarketing.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectMarketing) {
                // Update variables
                valueModelObjectMarketing.variables = action.payload.variables

                const marketingValueDriverObject = valueModelObjectMarketing.revenue_value_driver.marketing_driven.find(marketing_driver => marketing_driver.id === action.payload.marketing_driven.id);

                // If the attribute object is found, update its properties
                if (marketingValueDriverObject) {
                    Object.assign(marketingValueDriverObject, action.payload.marketing_driven);
                }
            }

            // Return the modified state
            return newStateMarketing;

        case DELETE_REVENUE_VALUE_DRIVER_MARKETING:
            const marketingDriver = action.payload;
            const deletedMarketing = _.filter(state.valueModel[marketingDriver.id].revenue_value_driver.marketing_driven, marketing_driver => marketing_driver.id !== marketingDriver.driver_id);

            const deletedCostValueDriverMarketing = {
                ...state.valueModel[marketingDriver.id].revenue_value_driver,
                marketing_driven: deletedMarketing
            };

            const deletedValueModelMarketing = {
                ...state.valueModel[marketingDriver.id],
                revenue_value_driver: deletedCostValueDriverMarketing,
                variables: marketingDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [marketingDriver.id]: deletedValueModelMarketing
                }
            };

        case ADD_REVENUE_VALUE_DRIVER_CLV: {
            const { id, lifetime_value, variables } = action.payload;
            const updatedCLV = [
                ...state.valueModel[id].revenue_value_driver.lifetime_value,
                lifetime_value
            ];

            const updatedRevenueValueDriver = {
                ...state.valueModel[id].revenue_value_driver,
                lifetime_value: updatedCLV
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                revenue_value_driver: updatedRevenueValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_REVENUE_VALUE_DRIVER_CLV:
            // Create a deep copy of the state
            const newStateCLV = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectCLV = newStateCLV.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectCLV) {
                // Update variables
                valueModelObjectCLV.variables = action.payload.variables

                const clvValueDriverObject = valueModelObjectCLV.revenue_value_driver.lifetime_value.find(clv_driver => clv_driver.id === action.payload.lifetime_value.id);

                // If the attribute object is found, update its properties
                if (clvValueDriverObject) {
                    Object.assign(clvValueDriverObject, action.payload.lifetime_value);
                }
            }

            // Return the modified state
            return newStateCLV;

        case DELETE_REVENUE_VALUE_DRIVER_CLV:
            const clvDriver = action.payload;
            const deletedCLV = _.filter(state.valueModel[clvDriver.id].revenue_value_driver.lifetime_value, clv_driver => clv_driver.id !== clvDriver.driver_id);

            const deletedCostValueDriverCLV = {
                ...state.valueModel[clvDriver.id].revenue_value_driver,
                lifetime_value: deletedCLV
            };

            const deletedValueModelCLV = {
                ...state.valueModel[clvDriver.id],
                revenue_value_driver: deletedCostValueDriverCLV,
                variables: clvDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [clvDriver.id]: deletedValueModelCLV
                }
            };

        case ADD_REVENUE_VALUE_DRIVER_IR: {
            const { id, incremental_revenue, variables } = action.payload;
            const updatedIR = [
                ...state.valueModel[id].revenue_value_driver.incremental_revenue,
                incremental_revenue
            ];

            const updatedRevenueValueDriver = {
                ...state.valueModel[id].revenue_value_driver,
                incremental_revenue: updatedIR
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                revenue_value_driver: updatedRevenueValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_REVENUE_VALUE_DRIVER_IR:
            // Create a deep copy of the state
            const newStateIR = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectIR = newStateIR.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectIR) {
                // Update variables
                valueModelObjectIR.variables = action.payload.variables

                const irValueDriverObject = valueModelObjectIR.revenue_value_driver.incremental_revenue.find(ir_driver => ir_driver.id === action.payload.incremental_revenue.id);

                // If the attribute object is found, update its properties
                if (irValueDriverObject) {
                    Object.assign(irValueDriverObject, action.payload.incremental_revenue);
                }
            }

            // Return the modified state
            return newStateIR;

        case DELETE_REVENUE_VALUE_DRIVER_IR:
            const irDriver = action.payload;
            const deletedIR = _.filter(state.valueModel[irDriver.id].revenue_value_driver.incremental_revenue, ir_driver => ir_driver.id !== irDriver.driver_id);

            const deletedCostValueDriverIR = {
                ...state.valueModel[irDriver.id].revenue_value_driver,
                incremental_revenue: deletedIR
            };

            const deletedValueModelIR = {
                ...state.valueModel[irDriver.id],
                revenue_value_driver: deletedCostValueDriverIR,
                variables: irDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [irDriver.id]: deletedValueModelIR
                }
            };

        case ADD_RISK_VALUE_DRIVER_REGULATORY: {
            const { id, regulatory_reduction, variables } = action.payload;
            const updatedRegulatory = [
                ...state.valueModel[id].risk_value_driver.regulatory_reduction,
                regulatory_reduction
            ];

            const updatedRiskValueDriver = {
                ...state.valueModel[id].risk_value_driver,
                regulatory_reduction: updatedRegulatory
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                risk_value_driver: updatedRiskValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_RISK_VALUE_DRIVER_REGULATORY:
            // Create a deep copy of the state
            const newStateRegulatory = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectRegulatory = newStateRegulatory.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectRegulatory) {
                // Update variables
                valueModelObjectRegulatory.variables = action.payload.variables

                const regulatoryValueDriverObject = valueModelObjectRegulatory.risk_value_driver.regulatory_reduction.find(regulatory_driver => regulatory_driver.id === action.payload.regulatory_reduction.id);

                // If the attribute object is found, update its properties
                if (regulatoryValueDriverObject) {
                    Object.assign(regulatoryValueDriverObject, action.payload.regulatory_reduction);
                }
            }

            // Return the modified state
            return newStateRegulatory;

        case DELETE_RISK_VALUE_DRIVER_REGULATORY:
            const regulatoryDriver = action.payload;
            const deletedRegulatory = _.filter(state.valueModel[regulatoryDriver.id].risk_value_driver.regulatory_reduction, regulatory_driver => regulatory_driver.id !== regulatoryDriver.driver_id);

            const deletedRiskValueDriverRegulatory = {
                ...state.valueModel[regulatoryDriver.id].risk_value_driver,
                regulatory_reduction: deletedRegulatory
            };

            const deletedValueModelRegulatory = {
                ...state.valueModel[regulatoryDriver.id],
                risk_value_driver: deletedRiskValueDriverRegulatory,
                variables: regulatoryDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [regulatoryDriver.id]: deletedValueModelRegulatory
                }
            };

        case ADD_RISK_VALUE_DRIVER_LITIGATION: {
            const { id, litigation_reduction, variables } = action.payload;
            const updatedLitigation = [
                ...state.valueModel[id].risk_value_driver.litigation_reduction,
                litigation_reduction
            ];

            const updatedRiskValueDriver = {
                ...state.valueModel[id].risk_value_driver,
                litigation_reduction: updatedLitigation
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                risk_value_driver: updatedRiskValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_RISK_VALUE_DRIVER_LITIGATION:
            // Create a deep copy of the state
            const newStateLitigation = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectLitigation = newStateLitigation.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectLitigation) {
                // Update variables
                valueModelObjectLitigation.variables = action.payload.variables

                const litigationValueDriverObject = valueModelObjectLitigation.risk_value_driver.litigation_reduction.find(litigation_driver => litigation_driver.id === action.payload.litigation_reduction.id);

                // If the attribute object is found, update its properties
                if (litigationValueDriverObject) {
                    Object.assign(litigationValueDriverObject, action.payload.litigation_reduction);
                }
            }

            // Return the modified state
            return newStateLitigation;

        case DELETE_RISK_VALUE_DRIVER_LITIGATION:
            const litigationDriver = action.payload;
            const deletedLitigation = _.filter(state.valueModel[litigationDriver.id].risk_value_driver.litigation_reduction, litigation_driver => litigation_driver.id !== litigationDriver.driver_id);

            const deletedRiskValueDriverLitigation = {
                ...state.valueModel[litigationDriver.id].risk_value_driver,
                litigation_reduction: deletedLitigation
            };

            const deletedValueModelLitigation = {
                ...state.valueModel[litigationDriver.id],
                risk_value_driver: deletedRiskValueDriverLitigation,
                variables: litigationDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [litigationDriver.id]: deletedValueModelLitigation
                }
            };

        case ADD_RISK_VALUE_DRIVER_REVENUE: {
            const { id, revenue_loss, variables } = action.payload;
            const updatedRevenue = [
                ...state.valueModel[id].risk_value_driver.revenue_loss,
                revenue_loss
            ];

            const updatedRiskValueDriver = {
                ...state.valueModel[id].risk_value_driver,
                revenue_loss: updatedRevenue
            };

            const updatedValueModel = {
                ...state.valueModel[id],
                risk_value_driver: updatedRiskValueDriver,
                variables: variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: updatedValueModel
                }
            };
        }

        case EDIT_RISK_VALUE_DRIVER_REVENUE:
            // Create a deep copy of the state
            const newStateRevenue = _.cloneDeep(state);

            // Take the valueModel object with the matching id
            const valueModelObjectRevenue = newStateRevenue.valueModel[action.payload.id];

            // If the valueModel object is found, find the cost value driver object with the matching id
            if (valueModelObjectRevenue) {
                // Update variables
                valueModelObjectRevenue.variables = action.payload.variables

                const revenueValueDriverObject = valueModelObjectRevenue.risk_value_driver.revenue_loss.find(revenue_driver => revenue_driver.id === action.payload.revenue_loss.id);

                // If the attribute object is found, update its properties
                if (revenueValueDriverObject) {
                    Object.assign(revenueValueDriverObject, action.payload.revenue_loss);
                }
            }

            // Return the modified state
            return newStateRevenue;

        case DELETE_RISK_VALUE_DRIVER_REVENUE:
            const revenueDriver = action.payload;
            const deletedRevenue = _.filter(state.valueModel[revenueDriver.id].risk_value_driver.revenue_loss, revenue_driver => revenue_driver.id !== revenueDriver.driver_id);

            const deletedRiskValueDriverRevenue = {
                ...state.valueModel[revenueDriver.id].risk_value_driver,
                revenue_loss: deletedRevenue
            };

            const deletedValueModelRevenue = {
                ...state.valueModel[revenueDriver.id],
                risk_value_driver: deletedRiskValueDriverRevenue,
                variables: revenueDriver.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [revenueDriver.id]: deletedValueModelRevenue
                }
            };

        case EDIT_VARIABLE_VALUES:
            const updatedVariables = action.payload;

            const updatedVariablesValueModel = {
                ...state.valueModel[updatedVariables.id],
                step: updatedVariables.step,
                variables: updatedVariables.variables
            };

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [updatedVariables.id]: updatedVariablesValueModel
                }
            };

        case EDIT_REVENUE_MODEL: {
            const { id, revenue_model } = action.payload;
            const prevVM = state.valueModel[id] || {};

            return {
                ...state,
                valueModel: {
                    ...state.valueModel,
                    [id]: {
                        ...prevVM,
                        driver_analysis: {
                            // preserve existing sections (cost_savings, etc.) if present
                            ...(prevVM.driver_analysis || {}),
                            // set the new field
                            revenue_model
                        }
                    }
                }
            };
        }

        case QUERY_COST_ITEM:
            return { ...state, queryResult: { id: action.payload.id, cost_type: action.payload.cost_type, cost_item: action.payload.cost_item } }

        case QUERY_COST_TYPE:
            return { ...state, queryResult: { id: action.payload.id, cost_type: action.payload.cost_type } }

        case QUERY_EMPLOYEE_TYPE:
            return { ...state, queryResult: { id: action.payload.id, employee_category: action.payload.employee_category, employee_type: action.payload.employee_type } }

        case QUERY_EMPLOYEE_CATEGORY:
            return { ...state, queryResult: { id: action.payload.id, employee_category: action.payload.employee_category } }

        case QUERY_INVESTMENT_PROJECT:
            return { ...state, queryResult: { id: action.payload.id, investment_asset: action.payload.investment_asset, investment_project: action.payload.investment_project } }

        case QUERY_INVESTMENT_ASSET:
            return { ...state, queryResult: { id: action.payload.id, investment_asset: action.payload.investment_asset } }

        case QUERY_PRODUCT_TYPE:
            return { ...state, queryResult: { id: action.payload.id, product_type: action.payload.product_type } }

        case QUERY_REVENUE_TYPE:
            return { ...state, queryResult: { id: action.payload.id, revenue_type: action.payload.revenue_type } }

        case CLEAR_QUERY_RESULT:
            return { ...state, queryResult: {} }

        default:
            return state;
    }
};

export default valueReducer